<template lang="pug">
FullScreenOverlaySlot(
  :isOpen="isOpen",
  headerIcon="primary-care",
  title="Referral Record"
  @closeOverlay="closeOverlay(false)"
)
  template(#breadcrumbs)
    h1.breadcrumbs-title ILLINOIS REFERRAL CARE
  template(#actionSection)
    BaseBtn.x-lg.blue-outline(
      href="#",
      @click.prevent="openProviderReferralNotesOverlay",
      :count="noteSummary.new"
    ) NOTES ({{ noteSummary.total }})
  template(#content)
    .card(style="padding-top: 52px;")
      .patient-info.columns.is-variable
        .column.is-two-thirds
          .columns.is-variable
            .info-pair.column.is-one-third
              .label Referral Date
              .txt.txt--blue {{ getDateFromUnixFormatted(showReferral.createdAt) }} 
            .info-pair.column.is-one-half
              .label Referral Time
              .txt.txt--blue {{ getTimeFromUnixFormatted(showReferral.createdAt) }} 
        .column.is-one-third
          .columns.is-variable
            .info-pair.column.is-one-half
              .label Confirmed
              .txt.txt--blue {{ getDateFromUnixFormatted(showReferral.confirmedDate) || "N/A"}}
            .info-pair.column.is-one-half
              .label Confirmed Date
              .txt.txt--blue {{ getTimeFromUnixFormatted(showReferral.confirmedDate) || "N/A" }} 

      .hr.hr--thin
      .columns.is-variable
        .info-pair.column.is-one-third
          .label First Name
          .txt.txt--blue {{ showReferral.patient.first }}
        .info-pair.column.is-one-third
          .label Last Name
          .txt.txt--blue {{ showReferral.patient.last }}
        .info-pair.column.is-one-third
          .label Date of Birth
          .txt.txt--blue {{ getDobFormattedforDateField(showReferral.patient.dob) }}
      .hr.hr--thin
      .info-pair.columns.is-variable
        .column.is-two-thirds.info-pair
          .label Patient Address
          .txt {{ showReferral.patient.address.address}}<br>{{ showReferral.patient.address.placeName }}, {{ showReferral.patient.address.state }} {{ showReferral.patient.address.zipCode }}
        .column.is-one-third.flex.flex--flex-start.flex--align-start
          .info-pair
            .label Patient Phone Number
            .txt {{ getPhoneFormatted(showReferral.patient.contact.cell_phone) }}
          .info-pair
            .label Ext.
            .txt {{ showReferral.patient.contact.cell_phone_extension }}
      .hr.hr.hr--thin
      .columns.is-variable
        .info-pair.column.is-one-third
          .label Community Care Name
          .txt {{ showReferral.communityCareOrganization.name }} 
        .info-pair.column.is-one-third(v-if="showReferral.provider")
          .label Staff Name
          .txt {{ showReferral.provider.first }} {{ showReferral.provider.last }}
        .column.is-one-third.flex.flex--flex-start.flex--align-start
          .info-pair
            .label {{ showReferral.referralModule.referralInfoSectionTitle }} 
            .txt.cursorPointer 
              base-icon(v-if="patientInfoQuestions?.length" name="eye-green", @click.prevent="openReferralInfoOverlay")
              base-icon(v-else name="eye-gray")
        
    .card.card--blue-bg
      .columns
        .info-pair.column.is-one-third
          .label Referral Status
          select(v-model="showReferral.referralStatus"
          :disabled = " showReferral.stage == 'CONTACTED' || showReferral.stage == 'UNABLE_TO_CONTACT' " )
            option(:value="null") Select
            option(value="RECEIVED") Received
            option(value="CONTACTED") Contacted
            option(value="UNABLE_TO_CONTACT") Unable to contact
        .info-pair.column.is-one-third(v-if="showReferral.referralModule.providerReport")
          .label Provider Report 
            span(v-if="!showReferral.referralModule.providerReportRequired") (Optional)
          UploadAndPreviewFile(
            :buttonStyleClasses="['btn', 'lg', 'blue']"
            :src="providerReportSrc"
            :storageKey="providerReportStorageKey"
            @fileLoaded="forceReRender"
            :disabled = "showReferral.stage == 'CONTACTED' || showReferral.stage == 'UNABLE_TO_CONTACT'" 
          )

      .columns(v-if="showReferral.referralModule.providerNotes")
        .info-pair.column.is-full
          .label Provider Notes 
            span(v-if="!showReferral.referralModule.providerNotesRequired") (Optional)
          textarea(
            style="height: 250px;" 
            v-model="showReferral.providerNotes"  
            :disabled = "showReferral.stage == 'CONTACTED' || showReferral.stage == 'UNABLE_TO_CONTACT'" 
          )

          
  template(#footer)
    BaseBtn.btn.lg.green-outline(
      :disabled="showReferral.referralStatus  != 'RECEIVED' "
      @click.prevent="preparePatchPatientAppointmentById()", 
    ) Save &amp; Exit
    BaseBtn.btn.lg.green( 
      @click.prevent="openCompleteAppointmentPopup()", 
      :disabled="v$.$invalid || isSubmitting ||  showReferral.referralStatus == '' ||  showReferral.referralStatus == 'RECEIVED' || showReferral.stage == 'CONTACTED' || showReferral.stage == 'UNABLE_TO_CONTACT' "
      :class="{spinner: isSubmitting }"
    ) Complete this Referral 

PopupCardSlot(
    :isOpen="isCompleteAppointmentPopupOpen",
    maxWidth="675px"
  )
    .complete-appointment-popup
      h1 Are you sure you want to complete this referral?
      p Please confirm to continue
      .popup-btns
        BaseBtn.x-lg.red-outline(@click.prevent="closeCompleteAppointmentPopup") CANCEL
        BaseBtn.x-lg.green(
          @click.prevent="prepareCompleteAppointmentPopup"
          :disabled="isSubmitting"
          :class="{spinner: isSubmitting }"
        ) YES, COMPLETE
PopupCardSlot(
    :isOpen="errorPopupOpen",
    maxWidth="675px"
  )
    .popup-error-content 
      h1 {{errorPopupMessage}}
      .popup-btns.center
        BaseBtn.x-lg.red-outline(@click.prevent="closeErrorPopup") CLOSE
    

ReferralInfoOverlay(
  :isOpen="isReferralInfoOverlayOpen",
  :overlayTitle="showReferral?.referralModule?.referralInfoSectionTitle || 'Patient Info Questions' ",
  :showReferral="showReferral"
  :showReferralDetails="showReferralDetails"
  :patientInfoQuestions="patientInfoQuestions"
  @closeReferralInfoOverlay="closeReferralInfoOverlay"
)

ProviderReferralNotesOverlay(
  :key="`${componentKey}-1`",
  :hasNoNotes="hasNoNotes",
  :isOpen="isProviderReferralNotesOverlayOpen",
  @closeOverlay="closeProviderReferralNotesOverlay"
  @fetchProviderPatientReferralNotifications="fetchProviderPatientReferralNotifications"
  :providerReferral="showReferral"
)
</template>

<script>
import UploadFileButton from "@/components/UploadFileButton";
import { defineComponent } from "vue";
import TimeDropdown from "@/components/TimeDropdown.vue";

import FileViewer from "@/components/files/FileViewer.vue";
import FullScreenOverlaySlot from "@/components/overlays/FullScreenOverlaySlot.vue";
import PopupCardSlot from "@/components/PopupCardSlot.vue";
import ReferralInfoOverlay from "@/components/provider-groups/referral-status/overlays/ReferralInfoOverlay.vue";
import UploadAndPreviewFile from "@/components/UploadAndPreviewFile";

import ProviderReferralNotesOverlay from "@/components/overlays/side-overlays/ProviderReferralNotesOverlay.vue";
import listPagesMixin from "@/mixins/listPagesMixin";

import {
  getDateFromUnixFormatted,
  getTimeFromUnixFormatted,
  getDobFormattedforDateField,
  getRelativeTimeFromUnixFormatted,
  getPhoneFormatted,
  getFileSignedUrl,
} from "@/helpers";
import {
  fetchProviderPatientReferralById,
  patchProviderPatientReferralById,
} from "@/api/providerPatientReferral";

import { fetchNotification } from "@/api/notifications.ts";

import { apiStatus } from "@/api";
import { fetchFileById, uploadFile } from "@/api/filesApi";
const { IDLE, PENDING, SUCCESS, ERROR } = apiStatus;

import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { maska } from "maska";

export default defineComponent({
  directives: { maska },
  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    let args = {
      showReferral: {
        referralStatus: { required },
      },
    };

    if (
      this.showReferral?.referralModule?.providerReport &&
      this.showReferral?.referralModule?.providerReportRequired
    ) {
      args.showReferral.idProviderReport = { required };
    }
    if (
      this.showReferral?.referralModule?.providerNotes &&
      this.showReferral?.referralModule?.providerNotesRequired
    ) {
      args.showReferral.providerNotes = { required };
    }
    return args;
  },
  components: {
    UploadFileButton,
    FullScreenOverlaySlot,
    PopupCardSlot,
    ReferralInfoOverlay,
    ProviderReferralNotesOverlay,
    FileViewer,
    UploadAndPreviewFile,
    TimeDropdown,
  },
  emits: ["closeProviderReferralRecordOverlay"],
  mixins: [listPagesMixin],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    tabType: {
      type: String,
      default: "",
    },
    showReferral: {
      type: Object,
    },
    specialtyModule: {
      required: false,
    },
  },
  data() {
    return {
      date: null,
      hasNoNotes: true,
      patientInfoQuestions: {},

      errorPopupOpen: false,
      errorPopupMessage: "",
      isSubmitting: false,

      getDateFromUnixFormatted: getDateFromUnixFormatted,
      getTimeFromUnixFormatted: getTimeFromUnixFormatted,
      getDobFormattedforDateField: getDobFormattedforDateField,
      getRelativeTimeFromUnixFormatted: getRelativeTimeFromUnixFormatted,
      getPhoneFormatted,

      isCompleteAppointmentPopupOpen: false,
      isReferralInfoOverlayOpen: false,

      fetchPatientAppointmentByIdStatus: IDLE,
      patchProviderPatientReferralByIdStatus: IDLE,
      fetchProviderPatientReferralNotificationsStatus: IDLE,
      showReferralDetails: null,

      isProviderReferralNotesOverlayOpen: false,
      noteSummary: {
        total: 0,
        new: 0,
      },
      providerReportStorageKey: "provider_report",
      idProviderReport: null,
      providerReportSrc: null,
      forcedReRenderTimes: 0,
    };
  },
  methods: {
    closeErrorPopup() {
      this.errorPopupOpen = false;
    },
    forceReRender() {
      this.forcedReRenderTimes++;
    },
    async fetchProviderPatientReferralNotifications() {
      this.fetchProviderPatientReferralNotificationsStatus = PENDING;
      try {
        const res = await fetchNotification({
          params: {
            idEntity: this.showReferral.id,
            entityType: "provider-referral",
          },
        });
        let newNotifications = res.data.notifications?.filter(
          (notification) => {
            return notification.status != "Completed";
          }
        );
        this.noteSummary.new = newNotifications?.length || 0;
        this.noteSummary.total = res.data.pagination?.quantity || 0;

        if (this.noteSummary.total > 0) {
          this.hasNoNotes = false;
        }
        this.fetchProviderPatientReferralNotificationsStatus = SUCCESS;
      } catch (err) {
        this.fetchProviderPatientReferralNotificationsStatus = ERROR;
        console.error(err);
      }
    },
    async prepareCompleteAppointmentPopup() {
      this.isSubmitting = true;
      if (this.showReferral.referralModule.providerReport) {
        await this.uploadProviderReport();
      }
      this.completeAppointmentPopup();
    },
    async completeAppointmentPopup() {
      this.patchProviderPatientReferralByIdStatus = PENDING;

      let stage = "";
      let status = this.showReferral.referralStatus;
      if (this.showReferral.referralStatus == "CONTACTED") {
        stage = "CONTACTED";
        status = "Contacted";
      } else if (this.showReferral.referralStatus == "UNABLE_TO_CONTACT") {
        stage = "UNABLE_TO_CONTACT";
        status = "Unable to Contact";
      }

      const sendArguments = {
        id: this.showReferral.id,
        stage: stage,
        status: status,
      };

      if (
        this.showReferral.referralModule.providerReport &&
        this.idProviderReport
      ) {
        sendArguments.idProviderReport = this.idProviderReport;
      }
      if (this.showReferral.referralStatus) {
        sendArguments.referralStatus = this.showReferral.referralStatus;
      }
      if (
        this.showReferral.referralModule.providerNotes &&
        this.showReferral.providerNotes
      ) {
        sendArguments.providerNotes = this.showReferral.providerNotes;
      }

      try {
        const res = await patchProviderPatientReferralById(
          this.showReferral.id,
          sendArguments
        );
        this.isCompleteAppointmentPopupOpen = false;

        this.patchProviderPatientReferralByIdStatus = SUCCESS;
        this.closeOverlay();
        this.isCompleteAppointmentPopupOpen = false;
        this.isSubmitting = false;
      } catch (err) {
        this.patchProviderPatientReferralByIdStatus = ERROR;
        console.error(err);
        this.errorPopupMessage = err?.response?.data?.message || err.message;
        this.errorPopupOpen = true;
      } finally {
        this.isSubmitting = false;
      }
    },
    preparePatchPatientAppointmentById() {
      this.patchProviderPatientReferralById().then(() => {
        this.closeOverlay();
      });
    },
    async patchProviderPatientReferralById() {
      if (this.showReferral.referralModule.providerReport) {
        await this.uploadProviderReport();
      }

      this.patchProviderPatientReferralByIdStatus = PENDING;
      this.isSubmitting = true;

      let stage = "REQUESTED";
      let status = "Received";

      const sendArguments = {
        id: this.showReferral.id,
        stage: stage,
        status: status,
      };

      if (
        this.showReferral.referralModule.providerReport &&
        this.idProviderReport
      ) {
        sendArguments.idProviderReport = this.idProviderReport;
      }
      if (this.showReferral.referralStatus) {
        sendArguments.referralStatus = this.showReferral.referralStatus;
      }
      if (
        this.showReferral.referralModule.providerNotes &&
        this.showReferral.providerNotes
      ) {
        sendArguments.providerNotes = this.showReferral.providerNotes;
      }

      try {
        await patchProviderPatientReferralById(
          this.showReferral.id,
          sendArguments
        );

        this.isCompleteAppointmentPopupOpen = false;

        this.patchProviderPatientReferralByIdStatus = SUCCESS;
      } catch (err) {
        this.patchProviderPatientReferralByIdStatus = ERROR;
        console.error(err);
        this.errorPopupMessage = err?.response?.data?.message || err.message;
        this.errorPopupOpen = true;
      } finally {
        this.isSubmitting = false;
      }
    },
    async fetchProviderPatientReferralById() {
      this.fetchPatientAppointmentByIdStatus = PENDING;
      try {
        const res = await fetchProviderPatientReferralById(
          this.showReferral.id,
          {
            params: {
              include: ["patient", "cbo", "providerReport", "referralModule"],
            },
          }
        );
        this.checkFetchFiles();
        this.showReferralDetails = res.data.providerPatientReferral;
        this.patientInfoQuestions =
          res.data.providerPatientReferral?.patientInfoQuestions;
        this.fetchPatientAppointmentByIdStatus = SUCCESS;
      } catch (err) {
        this.fetchPatientAppointmentByIdStatus = ERROR;
        console.error(err);
      }
    },
    closeOverlay(shouldRefresh = true) {
      this.clearFilesFromStorage();
      this.$emit("closeProviderReferralRecordOverlay", shouldRefresh);
    },
    openProviderReferralNotesOverlay() {
      this.componentKey++;
      this.isProviderReferralNotesOverlayOpen = true;
    },
    closeProviderReferralNotesOverlay() {
      this.fetchProviderPatientReferralNotifications();
      this.isProviderReferralNotesOverlayOpen = false;
    },
    openCompleteAppointmentPopup() {
      this.isCompleteAppointmentPopupOpen = true;
    },
    closeCompleteAppointmentPopup() {
      this.isCompleteAppointmentPopupOpen = false;
    },
    openReferralInfoOverlay() {
      this.isReferralInfoOverlayOpen = true;
    },
    closeReferralInfoOverlay() {
      this.isReferralInfoOverlayOpen = false;
    },
    clearFilesFromStorage() {
      sessionStorage.removeItem(this.providerReportStorageKey);
    },
    async uploadProviderReport() {
      const providerReport = sessionStorage.getItem(
        this.providerReportStorageKey
      );
      if (providerReport) {
        try {
          const { file } = await uploadFile(this.providerReportStorageKey);
          this.idProviderReport = file.id;
        } catch (error) {
          console.error(error);
        }
      }
      sessionStorage.removeItem(this.providerReportStorageKey);
    },
    async checkFetchFiles() {
      this.providerReportSrc = await this.fetchFileSrc(
        this.showReferral?.idProviderReport
      );
    },
    async fetchFileSrc(id) {
      if (!id) {
        return null;
      }

      try {
        const resFile = await fetchFileById(id);
        const file = resFile.data.file;
        file.token = resFile.data.token;
        return getFileSignedUrl(file);
      } catch (err) {
        console.error(err);
      }
    },
  },
  created() {
    if (this.showReferral === null) return;
    this.fetchProviderPatientReferralNotifications();
    this.fetchProviderPatientReferralById();
  },
});
</script>

<style scoped lang="scss">
.radio-custom {
  margin-right: 15px;
}
.flex-wrap {
  flex-wrap: wrap;
}
.margin-top {
  margin-top: 30px;
}
.spaceMarginTop {
  margin-top: 50px;
}
.time_spacer {
  margin-bottom: 46px;
}
.date_spacer {
  margin-bottom: 25px;
}
.info-pair .txt.font-medium {
  font-size: 18px;
  line-height: 28px;
  margin-top: 30px;
}
.cursorPointer svg {
  cursor: pointer;
}
.adjust-margin-top {
  margin-top: -8px;
}
.select-m-bot {
  margin-bottom: 25px;
}
.request_tab_confirm {
  margin-right: 0px;
  margin-left: auto;
}
.card {
  padding: 35px $secondaryCardsSidePadding 68px;
}
.columns.is-variable {
  --columnGap: 1.575%;
}
.columns + .hr {
  background-color: $primaryBgDarkGrey;
  margin-top: -21px;
  margin-bottom: 24px;
}
.card > .columns:last-child.info-pair,
.card > .columns:last-child .info-pair {
  margin-bottom: 0;
}
.svg-icon--eye-red,
.svg-icon--eye-gray,
.svg-icon--eye-green,
.svg-icon--yes,
.svg-icon--no {
  width: 50px;
  height: 50px;
  top: 0;
}

.rescheduled {
  .label {
    & > span {
      position: relative;
    }
    .svg-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: calc(100% + 20px);
    }
  }
}
.breadcrumbs-title {
  margin: 0;
  color: $primaryLightBlue;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.12px;
}

.complete-appointment-popup,
.popup-error-content {
  max-width: 555px;
  margin: 0 auto;
  h1 {
    width: 100%;
    max-width: 549px;
    margin: 39px auto 30px;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.21;
    letter-spacing: 0.14px;
    text-align: center;
  }
  p {
    margin-top: 0;
    margin-bottom: 32px;
    font-size: 16px;
    line-height: 1.19;
    letter-spacing: 0.23px;
    text-align: center;
  }
  .popup-btns {
    margin-bottom: 39px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      width: 260px;
    }
  }
  .popup-btns.center {
    justify-content: center;
  }
}
</style>
